/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendOtherProjectMembershipDto } from '../../models/backend-other-project-membership-dto';

export interface AccessProjectsMembersOtherProjectsList$Params {
  mid: number;
  project_id: number;
}

export function accessProjectsMembersOtherProjectsList(
  http: HttpClient,
  rootUrl: string,
  params: AccessProjectsMembersOtherProjectsList$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<Array<BackendOtherProjectMembershipDto>>> {
  const rb = new RequestBuilder(rootUrl, accessProjectsMembersOtherProjectsList.PATH, 'get');
  if (params) {
    rb.path('mid', params.mid, {});
    rb.path('project_id', params.project_id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<Array<BackendOtherProjectMembershipDto>>;
    }),
  );
}

accessProjectsMembersOtherProjectsList.PATH = '/api/access/projects/{project_id}/members/{mid}/other-projects/';
